module.exports = __webpack_public_path__ + "media/site_templates/www.localtilers.com.au/images/splash-222268a4f7af187355d0dea511a2ba89.jpeg";